export const TIME_FILTER = {
  LAST_7_DAYS: '7d',
  LAST_12_MONTHS: '12m',
  MONTH: 'month',
} as const;
